import { APP_NAME } from '../../constants';

import { NavigationElementType } from './Navigation.types';

export const NAVIGATION_ALICE_URL = `https://alice.yandex.ru?from=${APP_NAME}&utm_source=prompthub&utm_medium=candy`;

export const NAVIGATION_ICON_SIZES: Record<NavigationElementType, number> = {
    [NavigationElementType.Desktop]: 24,
    [NavigationElementType.Mobile]: 20,
};

export const NAVIGATION_OFFSET = 32;
export const NAVIGATION_MOBILE_OFFSET = 8;
